module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part4-f2171887.png";